/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import { Helmet } from "react-helmet-async";
import { makeStyles } from "@material-ui/core/styles";
import TopBanglesDescription from "views/InshaBanglesPage/Section/TopBanglesDescription";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";

const useStyles = makeStyles(aboutUsStyle);

export default function ReturnPolicy() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();

  const currentUrl =
    "https://inshabangles.com/top-bangles-manufacturers-in-india";
  const seoTitle = "Top Bangles Manufacturers in India | INSHA BANGLES";
  const seoDescription =
    "INSHA BANGLES is among the top bangles manufacturers in India, offering imitation jewellery, customized packaging, wholesale supply, and export-quality bangles.";
  const seoKeywords =
    "top bangles manufacturers in India, bangles manufacturer in Mumbai, imitation jewellery manufacturer, wholesale bangles supplier, bangles exporter in India, INSHA BANGLES";
  const ogImage =
    "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png";

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: "Top Bangles Manufacturers in India",
    description: seoDescription,
    author: {
      "@type": "Organization",
      name: "INSHA BANGLES",
    },
    publisher: {
      "@type": "Organization",
      name: "INSHA BANGLES",
      logo: {
        "@type": "ImageObject",
        url: ogImage,
      },
    },
    mainEntityOfPage: currentUrl,
  };

  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="INSHA BANGLES" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>
      <div className={classNames(classes.main)}>
        <div className={classes.container}>
          <TopBanglesDescription />
          <br />
        </div>
      </div>
    </div>
  );
}
